module.exports = __webpack_public_path__ + "img/dodCalendarIcon.b6503eaf.svg";